import React__default from 'react';
import { useStytchIsAuthorized as useStytchIsAuthorized$1, useStytchMember as useStytchMember$1, useStytchMemberSession as useStytchMemberSession$1, useStytchOrganization as useStytchOrganization$1, withStytchMember as withStytchMember$1, withStytchMemberSession as withStytchMemberSession$1, withStytchOrganization as withStytchOrganization$1, StytchB2BProvider as StytchB2BProvider$1 } from '../packages/web/src/ui/react/b2b/StytchB2BContext.mjs';
export { useStytchB2BClient, withStytchB2BClient, withStytchPermissions } from '../packages/web/src/ui/react/b2b/StytchB2BContext.mjs';

/**
 * Returns the active Member.
 * The Stytch SDKs are used for client-side authentication and session management.
 * Check the isInitialized property to determine if the SDK has completed initialization.
 * Check the fromCache property to determine if the member data is from persistent storage.
 * @example
 * const {member, isInitialized, fromCache} = useStytchMember();
 * if (!isInitialized) {
 *   return <p>Loading...</p>;
 * }
 * return (<h1>Welcome, {member.name}</h1>);
 */ const useStytchMember = useStytchMember$1;
/**
 * Returns the active member's Stytch member session.
 * The Stytch SDKs are used for client-side authentication and session management.
 * Check the isInitialized property to determine if the SDK has completed initialization.
 * Check the fromCache property to determine if the session data is from persistent storage.
 * @example
 * const {session, isInitialized, fromCache} = useStytchMemberSession();
 * useEffect(() => {
 *   if (!isInitialized) {
 *     return;
 *   }
 *   if (!session) {
 *     router.replace('/login');
 *   }
 * }, [session, isInitialized]);
 */ const useStytchMemberSession = useStytchMemberSession$1;
/**
 * Returns the active Stytch organization.
 * The Stytch SDKs are used for client-side authentication and session management.
 * Check the isInitialized property to determine if the SDK has completed initialization.
 * Check the fromCache property to determine if the organization data is from persistent storage.
 * @example
 * const {organization, isInitialized, fromCache} = useStytchOrganization();
 * if (!isInitialized) {
 *   return <p>Loading...</p>;
 * }
 * return <p>Welcome to {organization.organization_name}</p>;
 */ const useStytchOrganization = useStytchOrganization$1;
/**
 * Determines whether the logged-in member is allowed to perform the specified action on the specified resource.
 * Returns `true` if the member can perform the action, `false` otherwise.
 *
 * If the member is not logged in, this method will always return false.
 * If the resource or action provided are not valid for the configured RBAC policy, this method will return false.
 *
 * Remember - authorization checks for sensitive actions should always occur on the backend as well.
 * @example
 * const { isAuthorized } = useStytchIsAuthorized('documents', 'edit');
 * return <button disabled={!isAuthorized}>Edit</button>
 */ const useStytchIsAuthorized = useStytchIsAuthorized$1;
const withStytchMember = withStytchMember$1;
const withStytchMemberSession = withStytchMemberSession$1;
const withStytchOrganization = withStytchOrganization$1;
/**
 * The Stytch Context Provider.
 * Wrap your application with this component in order to use Stytch everywhere in your app.
 * @example
 * const stytch = createStytchB2BClient('public-token-<find yours in the stytch dashboard>')
 *
 * ReactDOM.render(
 *   <StytchB2BProvider stytch={stytch}>
 *     <App />
 *   </StytchProvider>,
 *   document.getElementById('root'),
 * )
 */ const StytchB2BProvider = ({ stytch, children, assumeHydrated = true })=>/*#__PURE__*/ React__default.createElement(StytchB2BProvider$1, {
        stytch: stytch,
        assumeHydrated: assumeHydrated
    }, children);

export { StytchB2BProvider, useStytchIsAuthorized, useStytchMember, useStytchMemberSession, useStytchOrganization, withStytchMember, withStytchMemberSession, withStytchOrganization };
//# sourceMappingURL=StytchB2BContext.mjs.map
